module.exports = "/dist/d5615136a08cfee70deb4be1ee1651df.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-600.woff2
// module id = 129
// module chunks = 0